import * as React from 'react';
import { SVGProps } from 'react';

const SvgSplunk = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" xmlSpace="preserve" {...props}>
    <linearGradient
      id="splunk_svg__a"
      gradientUnits="userSpaceOnUse"
      x1={2.929}
      y1={17.071}
      x2={17.071}
      y2={2.929}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#ec0080',
        }}
      />
      <stop
        offset={0.6}
        style={{
          stopColor: '#f5891f',
        }}
      />
      <stop
        offset={0.957}
        style={{
          stopColor: '#ed106d',
        }}
      />
    </linearGradient>
    <circle
      cx={10}
      cy={10}
      r={10}
      style={{
        fill: 'url(#splunk_svg__a)',
      }}
    />
    <path
      d="M3.706 10.502a.655.655 0 0 1-.255.524.915.915 0 0 1-.287.147 1.208 1.208 0 0 1-.364.052c-.158 0-.3-.021-.424-.065A1.256 1.256 0 0 1 2 10.946l.208-.337c.099.083.189.144.27.183.08.039.162.057.246.057a.37.37 0 0 0 .249-.08.267.267 0 0 0 .093-.215.34.34 0 0 0-.017-.108.335.335 0 0 0-.062-.105.82.82 0 0 0-.126-.116 6.704 6.704 0 0 0-.205-.154 6.515 6.515 0 0 1-.188-.139 1.647 1.647 0 0 1-.167-.154.707.707 0 0 1-.121-.184.577.577 0 0 1-.046-.233.606.606 0 0 1 .232-.484.783.783 0 0 1 .26-.136c.101-.032.21-.049.33-.049a1.288 1.288 0 0 1 .689.197l-.187.304a.696.696 0 0 0-.405-.136.332.332 0 0 0-.214.067.208.208 0 0 0-.085.17c0 .065.025.123.075.174.05.052.136.123.257.218.123.09.225.169.305.237.081.067.144.132.192.192a.557.557 0 0 1 .123.387zm2.133-.569c0 .093-.01.194-.03.303a1.058 1.058 0 0 1-.099.3.665.665 0 0 1-.184.227.453.453 0 0 1-.289.09.534.534 0 0 1-.459-.233c-.112-.156-.168-.368-.168-.639 0-.278.056-.497.17-.66a.532.532 0 0 1 .461-.244c.184 0 .33.077.437.229.108.154.161.363.161.627zm.674-.024c0-.181-.026-.345-.077-.492a1.116 1.116 0 0 0-.22-.382 1.024 1.024 0 0 0-.771-.339 1.04 1.04 0 0 0-.459.098c-.132.067-.255.17-.367.312l-.004-.352h-.62v3.622h.619v-1.53c.061.071.119.131.177.179a.838.838 0 0 0 .172.118c.058.03.119.052.184.065a1.14 1.14 0 0 0 .668-.079c.142-.066.265-.158.368-.278.103-.12.184-.259.243-.417a1.51 1.51 0 0 0 .087-.525zm.276 1.259h.637V7.624h-.637v3.544zm3.353.001V8.751h-.636v1.301c0 .116-.005.205-.015.269a.69.69 0 0 1-.049.172c-.09.199-.255.3-.495.3-.188 0-.318-.067-.393-.203a.514.514 0 0 1-.061-.174 1.784 1.784 0 0 1-.017-.281V8.751h-.637v1.373l.002.237a1.678 1.678 0 0 0 .034.305c.007.039.02.076.036.111.058.148.152.26.282.336a.942.942 0 0 0 .48.113c.17 0 .321-.03.45-.09s.255-.157.377-.293l.001.324.641.002zm2.744-.001V9.797l-.002-.239a1.377 1.377 0 0 0-.036-.299.677.677 0 0 0-.316-.443.916.916 0 0 0-.482-.118c-.17 0-.321.03-.45.09s-.255.158-.377.293l-.001-.324h-.641v2.413h.642V9.867c0-.112.004-.2.012-.263a.699.699 0 0 1 .046-.177c.041-.097.106-.169.192-.219s.188-.075.307-.075c.188 0 .318.067.393.203.029.051.049.11.06.173.011.064.017.158.017.28v1.377l.636.002zm2.634-.159-.97-1.207.82-.879-.483-.208-.853.99h-.067V7.624h-.642v3.544h.642V9.884l.96 1.332.593-.207zm2.48-.867v-.395l-1.929-.969v.435l1.495.728-1.495.738v.425L18 10.142zm-1.742-1.99a.216.216 0 0 0-.214.217c0 .122.096.218.214.218a.215.215 0 0 0 .214-.218.215.215 0 0 0-.214-.217zm.001.034c.096 0 .173.082.173.184s-.077.184-.173.183c-.097 0-.174-.081-.174-.184 0-.101.077-.183.174-.183zm-.041.205h.026c.031 0 .046.011.052.042a.193.193 0 0 0 .016.061h.041a.17.17 0 0 1-.015-.06c-.005-.036-.019-.055-.041-.059v-.001c.026-.007.047-.027.047-.059 0-.022-.008-.04-.022-.05a.126.126 0 0 0-.075-.019.317.317 0 0 0-.068.006v.242h.039v-.103zm0-.112a.165.165 0 0 1 .027-.002c.044 0 .058.021.058.042 0 .03-.027.041-.058.041h-.027v-.081z"
      style={{
        fill: '#fff',
      }}
    />
  </svg>
);

export default SvgSplunk;
